import { words } from './globalState';

// NFCボタン押下 READ NFC
async function readNfc({ dispatch, resolve, reject, language } = {}) {
  if ('NDEFReader' in window) {
    const ndef = new window.NDEFReader();
    await ndef.scan();

    ndef.onreading = async (event) => {
      console.log("NDEF tag detected");

      // 先に後処理やっちゃう。
      ndef.onreading = null;
      ndef.onreadingerror = null;

      resolve(event.message.records);
    };

    ndef.onreadingerror = () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.cannotReadDataFromNfc[language] });

      ndef.onreading = null;
      ndef.onreadingerror = null;

      reject(new Error('cannotReadDataFromNfc'));
    };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.yourDeviceDoesNotSupportNfc[language] });

    reject(new Error('deviceDoesNotSupportNfc'));
  }
}

// NFC書き込み WRITE MNEMONIC ON NFC
async function writeOnNfc(state, dispatch, data, { language: languageOpt } = {}) {
  const language = languageOpt ?? state?.language;

  if (!('NDEFReader' in window)) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.yourDeviceDoesNotSupportKeyCards[language] });
    return;
  }

  const ndef = new window.NDEFReader();

  const result = await ndef.write({
    records: [
      {
        recordType: "url",
        data: "https://knightsofmonadom.monatoka.com/?wallettype=nfc"
      },
      {
        recordType: "text",
        lang: "en",
        encoding: "utf-8",
        data,
        // data: state.displaySecret.mnemonicToWif,
      },
    ]
  })
  .then( (result) => {
    dispatch({ type: 'setNotification', key: 'notification', value: 'NDEF messages written!' });
    return;
  })
  .catch( (error) => {
    dispatch({ type: 'setNotification', key: 'notification', value: 'Failed to write NDEF messages.' });
    throw new Error(error + data);
  });

  return result;
}

// NFC書き込み WRITE MNEMONIC ON NFC
async function writeNdefRecordsOnNfc({ dispatch, records, language } = {}) {
  if (!('NDEFReader' in window)) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.yourDeviceDoesNotSupportKeyCards[language] });
    throw new Error('deviceDoesNotSupportNfc');
  }

  const ndef = new window.NDEFReader();

  const result = await ndef.write({
    records: records,
  })
  .then( (result) => {
    dispatch({ type: 'setNotification', key: 'notification', value: words.wroteOnNfc[language] });
    return result;
  })
  .catch( (error) => {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToWriteOnNfc[language] });
    throw new Error(error + records);
  });

  return result;
}

// バイト列を Base64URL にする
function bytesToBase64Url({ bytes }) {
  let binary = '';

  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }

  const b64 = window.btoa(binary);

  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

// Base64URL をバイト列に戻す
function bytesFromBase64Url({ str }) {
  const b64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
  const binary = window.atob(padded);

  return Uint8Array.from(binary, (ch) => ch.charCodeAt(0));
}

// JSON を Base64URL にする
function toBase64Url({ obj }) {
  const json = JSON.stringify(obj);
  const bytes = new TextEncoder().encode(json);

  return bytesToBase64Url({ bytes });
}

// Base64URL を JSON に戻す
function fromBase64Url({ str }) {
  const bytes = bytesFromBase64Url({ str });
  const json = new TextDecoder().decode(bytes);

  return JSON.parse(json);
}

// DECODE NDEF RECORD
function decodeNdefRecord({ dispatch, record, language } = {}) {
  if (!record) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.cannotReadDataFromNfc[language] });
    throw new Error('cannotFindRecord');
  }

  // Web NFC の Text レコードは { recordType: "text", encoding, data(DataView) } の形
  let text;
  if (typeof record.data === 'string') {
    text = record.data;
  }
  else if (record.data != null) {
    try {
      const decoder = new TextDecoder(record.encoding ?? 'utf-8');
      text = decoder.decode(record.data);
    }
    catch (error) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.cannotReadDataFromNfc[language] });
      throw new Error('cannotDecodeData');
    }
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.cannotReadDataFromNfc[language] });
    throw new Error('cannotDecodeData');
  }

  return text;
}

// HANDLE CLICK GO TOP
function handleClickGoTop({ navigate }) {
  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/top' : '/top');
}

// CLEAN UP OBJECT
function cleanUpObject(object) {
  if (Array.isArray(object)) {
    for (const [index, value] of object.entries()) {
      const isEmpty = cleanUpObject(value);

      if (isEmpty) {
        object.splice(index, 1);
      }
    }

    if (object.length <= 0) {
      return true;
    }
    else {
      return false;
    }
  }
  else if (typeof object === 'object' && object !== null) {
    for (const key of Object.keys(object)) {
      const isEmpty = cleanUpObject(object[key]);

      if (isEmpty) {
        delete object[key];
      }
    }

    if (Object.keys(object).length <= 0) {
      return true;
    }
    else {
      return false;
    }
  }
  else {
    return false;
  }
}

// HTTPリクエスト（同期バージョン2）
async function syncHttpRequest2(request, setResultKey, sortFunction, setNotificationKey, messages, dispatch) {
  if (request.headers === undefined) {
    request.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
  }

  if (request.method === undefined) {
    request.method = 'POST';
  }

  const result = await fetch(request.url, { method: request.method, headers: request.headers, body: request.body })
  .then( response => response.json() )
  .then( async json => {
           const applicationMessage = json.applicationMessage;

           devLog(applicationMessage, messages[applicationMessage], 'setNotificationKey', setNotificationKey);

           if (setNotificationKey !== undefined) {
             devLog('inner', setNotificationKey);
             dispatch({ type: 'setNotification', key: setNotificationKey,
                        value: (messages[applicationMessage] ? messages[applicationMessage] : applicationMessage) });  
           }

           if (json.applicationStatus.substring(0,1) === '2') {
             let body = json.body;

             if (setResultKey !== undefined) {
               devLog(setResultKey);
               devLog(JSON.stringify(body));

               if (sortFunction !== undefined) {
                 body.sort(sortFunction);
               }

               dispatch({ type: 'setState', key: setResultKey, value: body });
             }

             return { status: 'fulfilled', body: body, error: json.errors };
           }
           else {
             return { status: 'rejected', body: json.body };
           }
         }
  )
  .catch( error => {
           return { status: 'rejected', error: error };
          }
  );

  return result;
}

// HTTPリクエスト（同期バージョン／例外スロー）
// SYNC HTTP REQUEST OR THROW
async function syncHttpRequestOrThrow(request) {
  if (request.headers === undefined) {
    request.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
  }

  try {
    const response = await fetch(request.url, { method: request.method, headers: request.headers, body: request.body });
    const json = await response.json();
    devLog('syncHttpRequestOrThrow fulfilled', JSON.stringify(json));
    return json;
  } catch (error) {
    devLog('syncHttpRequestOrThrow rejected', JSON.stringify(error));
    throw error;
  }
}

async function hasCamera() {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.some(device => device.kind === 'videoinput');
  } catch (error) {
    devLog("An error occurred:", error);
    return false;
  }
}

// ネイティブ NFC アプリが起動できる端末か
// Core NFC は iPhone のみ。iPad / iPod は NFC 読み書きができず、
// iPadOS のデスクトップ UA（MacIntel + タッチ）まで含めると誤って候補に出る。
// アプリのインストール有無は Web から判定できないため、端末種別で見る。
function isIPhone() {
  return /iPhone/i.test(navigator.userAgent);
}

// SET EPOCH TIME
// eslint-disable-next-line no-unused-vars
function setEpochTime(state, dispatch, keys, changedProperty, changedValue) {
  const time = keys.reduce( (acc, cur) => { return acc[cur]; }, state );

  const year = changedProperty === 'year' ? changedValue : time.year;
  const month = changedProperty === 'month' ? changedValue - 1 : time.month - 1;
  const day = changedProperty === 'day' ? changedValue : time.day;
  const hours = changedProperty === 'hours' ? changedValue : time.hours;
  const minutes = changedProperty === 'minutes' ? changedValue : time.minutes;
  const seconds = changedProperty === 'seconds' ? changedValue : time.seconds;
  const milliseconds = changedProperty === 'milliseconds' ? changedValue : time.milliseconds;

  const keysEpoch = keys.concat(['epoch']);

  dispatch({
    type: 'setStateMultiLayersNum',
    keys: keysEpoch,
    value: new Date(year, month, day, hours, minutes, seconds, milliseconds).getTime()
  });
}

// LOCAL TIME
// eslint-disable-next-line no-unused-vars
function localTime(epoch, format) {
  const epochNum = parseInt(epoch, 10);
  let time;

  if (Number.isNaN(epochNum) || epochNum === '' || epochNum === undefined) {
    return '';
  }

  time = new Date(epochNum);

  if (format === 'yearToMinute') {
    return `${time.getFullYear()}/${(time.getMonth() + 1).toString().padStart(2, '0')}/${time.getDate().toString().padStart(2, '0')} ${time.getHours().toString().padStart(2, '0')}:${time.getMinutes().toString().padStart(2, '0')}`;
  }
  else if (format === 'yearToSecond') {
    return `${time.getFullYear()}/${(time.getMonth() + 1).toString().padStart(2, '0')}/${time.getDate().toString().padStart(2, '0')} ${time.getHours().toString().padStart(2, '0')}:${time.getMinutes().toString().padStart(2, '0')}:${time.getSeconds().toString().padStart(2, '0')}`;
  }
  else if (format === 'digit14Num') {
    return parseInt(`${time.getFullYear()}${(time.getMonth() + 1).toString().padStart(2, '0')}${time.getDate().toString().padStart(2, '0')}${time.getHours().toString().padStart(2, '0')}${time.getMinutes().toString().padStart(2, '0')}${time.getSeconds().toString().padStart(2, '0')}`, 10);
  }
  else {
    return `${time.getFullYear()}/${(time.getMonth() + 1).toString().padStart(2, '0')}/${time.getDate().toString().padStart(2, '0')} ${time.getHours().toString().padStart(2, '0')}:${time.getMinutes().toString().padStart(2, '0')}:${time.getSeconds().toString().padStart(2, '0')}.${time.getMilliseconds()}`;
  }
}

// MINUTES AND SECONDS
// eslint-disable-next-line no-unused-vars
function minutesAndSeconds(milliseconds) {
  if (milliseconds <= 0) {
    return '00:00';
  }

  const seconds = Math.floor(milliseconds / 1000); 
  return Math.floor(seconds / 60).toString().padStart(2, '0') + ':' + (seconds % 60).toString().padStart(2, '0');
}

// URL PARAMS STRINGIFY
// eslint-disable-next-line no-unused-vars
function urlParamsStringify(urlParams) {
  return urlParams.reduce( (acc, cur) => {
    if (cur !== null) {
      return acc + (acc === '' ? '?' : '&') + cur;
    }
    else {
      return acc;
    }
  }, '' );
}

// COPY TO CLIPBOARD
// eslint-disable-next-line no-unused-vars
function copyToClipboard(text, textAreaRef) {
  if (textAreaRef.current) {
    textAreaRef.current.value = text;
    textAreaRef.current.select();
    document.execCommand('copy');
  }
}

// QRボタン押下 HANDLE CLICK SCAN QR
function handleClickScanQr(state, dispatch, callback, { args = ['keyPairs'], recordNos = [0], callbackType = 'decryptMnemonic', popupLayer = 0 } = {}) {
  const popup = {
    type: 'qrCodeScannerPopup',
    body: {
      callback,
      callbackType,
      options: { args, recordNos },
    },
  };

  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: popup });
}

// DECIMAL ADJUST
function decimalAdjust(type, value, exp) {
  // If the exp is undefined or zero...
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }
  // If value is Infinity...
  if (value === Infinity) {
    return Infinity;
  }
  value = +value;
  exp = +exp;
  // If the value is not a number or the exp is not an integer...
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }
  // Shift
  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}

function toFloat(string) {
  if (Number.isFinite(string) || string === Infinity) {
    return string;
  }

  const numericCharacter = string.replace(/[^\d.]/, '');
  let float = parseFloat(numericCharacter);

  if (Number.isNaN(float)) {
    float = ''
  }

  return float;
}

// ADJUST MULTI LAYERS FLOAT
function adjustFloat(type, value, exp) {
  let number = parseFloat(value);

  if (Number.isNaN(number)) {
    number = ''
  }
  else if (type !== undefined) {
    number = decimalAdjust(type, number, exp);
  }

  return number;
}

// SLEEP
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// ArrayBufferをBase64文字列に変換する関数
function arrayBufferToBase64(buffer) {
    // ArrayBufferからバイナリ文字列を生成
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    // window.btoa関数でバイナリ文字列をBase64にエンコード
    return window.btoa(binary);
}

// HTTPリクエスト（同期バージョン）
// SYNC HTTP REQUEST
async function syncHttpRequest(request) {
  if (request.headers === undefined) {
    request.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
  }

  return await fetch(request.url, { method: request.method, headers: request.headers, body: request.body })
  .then( response => response.json() )
  .then( json => {
    devLog('syncHttpRequest fulfilled', JSON.stringify(json));
    return {
      status: 'fulfilled',
      body: json,
    };
  })
  .catch( error => {
    devLog('syncHttpRequest rejected', JSON.stringify(error));
    return {
      status: 'rejected',
      body: error,
      error: error,
    };
  });
}

// HTTPリクエスト テキスト（同期バージョン）
// SYNC HTTP REQUEST TEXT
async function syncHttpRequestText(request) {
  if (request.headers === undefined) {
    request.headers = {
      'Accept': 'text/plain',
      'Content-Type': 'text/plain',
    };
  }

  return await fetch(request.url, { method: request.method, headers: request.headers, body: request.body })
  .then( response => response.text() )
  .then( text => {
    devLog('syncHttpRequestText fulfilled', text);
    return {
      status: 'fulfilled',
      body: text,
    };
  })
  .catch( error => {
    devLog('syncHttpRequestText rejected', error);
    return {
      status: 'rejected',
      body: error,
      error: error,
    };
  });
}

// POST JSON
async function postJson(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json; charset=utf-8' },
    body: JSON.stringify(body),
    mode: 'cors',
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data?.error || `HTTP ${res.status}`);
  }

  return data;
}

function wrapErrorWithCause(message, error) {
  const cause = error instanceof Error ? error : new Error(String(error));
  const wrappedError = new Error(message);
  wrappedError.cause = cause;

  return wrappedError;
}

function notificationMessageWithError(prefixMessage, error) {
  const errorMessage =
    error && typeof error === 'object' && 'message' in error
      ? error.message
      : error;

  return `${prefixMessage}: ${String(errorMessage)}`;
}

// UPSERT COMPOSITE RECORD IN INDEXEDDB
// 複合キーを使ってレコードを保存（既存キーは上書き）
async function upsertCompositeRecordInIndexedDb({
  dbName,
  storeName,
  keyFields,
  record,
  version = 1,
  keyPath = 'id',
  onUpgrade,
}) {
  if (!dbName || !storeName) {
    throw new Error('dbName と storeName は必須です');
  }
  if (!Array.isArray(keyFields) || keyFields.length === 0) {
    throw new Error('keyFields は1件以上のフィールド名を含む配列で指定してください');
  }
  if (!record || typeof record !== 'object') {
    throw new Error('record はオブジェクトで指定してください');
  }

  const missing = keyFields.filter((field) => !record[field]);
  if (missing.length > 0) {
    throw new Error(`複合キーに必要なフィールドが不足しています: ${missing.join(', ')}`);
  }

  const compositeKey = keyFields.map((field) => String(record[field])).join('::');

  const openRequest = indexedDB.open(dbName, version);
  const db = await new Promise((resolve, reject) => {
    openRequest.onupgradeneeded = (event) => {
      const dbInstance = event.target.result;
      if (!dbInstance.objectStoreNames.contains(storeName)) {
        dbInstance.createObjectStore(storeName, { keyPath });
      }
      // 追加のインデックス作成などが必要なら呼び出し側で onUpgrade を指定
      if (typeof onUpgrade === 'function') {
        onUpgrade(dbInstance);
      }
    };
    openRequest.onsuccess = (event) => resolve(event.target.result);
    openRequest.onerror = (event) => reject(event.target.error);
  });

  try {
    await new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);

      store.put({
        [keyPath]: compositeKey,
        ...record,
        updatedAt: new Date().toISOString(),
      });

      tx.oncomplete = () => resolve();
      tx.onerror = (event) => reject(event.target.error);
      tx.onabort = (event) => reject(event.target.error);
    });
  } finally {
    db.close();
  }

  return compositeKey;
}

// UPDATE COMPOSITE RECORD IN INDEXEDDB
// 既存レコードがあれば部分更新し、無ければ新規作成
async function updateCompositeRecordInIndexedDb({
  dbName,
  storeName,
  keyFields,
  keySource,
  changes,
  version = 1,
  keyPath = 'id',
  onUpgrade,
}) {
  if (!dbName || !storeName) {
    throw new Error('dbName と storeName は必須です');
  }
  if (!Array.isArray(keyFields) || keyFields.length === 0) {
    throw new Error('keyFields は1件以上のフィールド名を含む配列で指定してください');
  }
  if (!keySource || typeof keySource !== 'object') {
    throw new Error('keySource はオブジェクトで指定してください');
  }
  if (!changes || typeof changes !== 'object') {
    throw new Error('changes はオブジェクトで指定してください');
  }

  const missing = keyFields.filter((field) => !keySource[field]);
  if (missing.length > 0) {
    throw new Error(`複合キーに必要なフィールドが不足しています: ${missing.join(', ')}`);
  }

  const changedKeyFields = keyFields.filter((field) => Object.prototype.hasOwnProperty.call(changes, field));
  if (changedKeyFields.length > 0) {
    throw new Error(`複合キーのフィールドは変更できません: ${changedKeyFields.join(', ')}`);
  }

  const compositeKey = keyFields.map((field) => String(keySource[field])).join('::');

  const openRequest = indexedDB.open(dbName, version);
  const db = await new Promise((resolve, reject) => {
    openRequest.onupgradeneeded = (event) => {
      const dbInstance = event.target.result;
      if (!dbInstance.objectStoreNames.contains(storeName)) {
        dbInstance.createObjectStore(storeName, { keyPath });
      }
      if (typeof onUpgrade === 'function') {
        onUpgrade(dbInstance);
      }
    };
    openRequest.onsuccess = (event) => resolve(event.target.result);
    openRequest.onerror = (event) => reject(event.target.error);
  });

  try {
    const updatedRecord = await new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);
      const getRequest = store.get(compositeKey);
      let nextRecord = null;

      getRequest.onsuccess = () => {
        const existingRecord = getRequest.result ?? {};

        // 新規作成時も複合キーの元フィールドを必ず保持する
        nextRecord = {
          ...existingRecord,
          ...keySource,
          ...changes,
          [keyPath]: compositeKey,
          updatedAt: new Date().toISOString(),
        };

        const putRequest = store.put(nextRecord);
        putRequest.onerror = (event) => reject(event.target.error);
      };

      getRequest.onerror = (event) => reject(event.target.error);
      tx.oncomplete = () => resolve(nextRecord);
      tx.onerror = (event) => reject(event.target.error);
      tx.onabort = (event) => reject(event.target.error);
    });

    return updatedRecord;
  } finally {
    db.close();
  }
}

// GET ALL RECORDS FROM INDEXEDDB
async function getAllRecordsFromIndexedDb({
  dbName,
  storeName,
  version = 1,
  keyPath = 'id',
  onUpgrade,
}) {
  if (!dbName || !storeName) {
    throw new Error('dbName と storeName は必須です');
  }

  const openRequest = indexedDB.open(dbName, version);
  const db = await new Promise((resolve, reject) => {
    openRequest.onupgradeneeded = (event) => {
      const dbInstance = event.target.result;
      if (!dbInstance.objectStoreNames.contains(storeName)) {
        dbInstance.createObjectStore(storeName, { keyPath });
      }
      if (typeof onUpgrade === 'function') {
        onUpgrade(dbInstance);
      }
    };
    openRequest.onsuccess = (event) => resolve(event.target.result);
    openRequest.onerror = (event) => reject(event.target.error);
  });

  try {
    const records = await new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, 'readonly');
      const store = tx.objectStore(storeName);
      const request = store.getAll();

      request.onsuccess = () => resolve(request.result ?? []);
      request.onerror = (event) => reject(event.target.error);
      tx.onerror = (event) => reject(event.target.error);
      tx.onabort = (event) => reject(event.target.error);
    });

    return records;
  } finally {
    db.close();
  }
}

// GET COMPOSITE RECORD FROM INDEXEDDB
async function getCompositeRecordFromIndexedDb({
  dbName,
  storeName,
  keyFields,
  keySource,
  version = 1,
  keyPath = 'id',
  onUpgrade,
}) {
  if (!dbName || !storeName) {
    throw new Error('dbName と storeName は必須です');
  }
  if (!Array.isArray(keyFields) || keyFields.length === 0) {
    throw new Error('keyFields は1件以上のフィールド名を含む配列で指定してください');
  }
  if (!keySource || typeof keySource !== 'object') {
    throw new Error('keySource はオブジェクトで指定してください');
  }

  const missing = keyFields.filter((field) => !keySource[field]);
  if (missing.length > 0) {
    throw new Error(`複合キーに必要なフィールドが不足しています: ${missing.join(', ')}`);
  }

  const compositeKey = keyFields.map((field) => String(keySource[field])).join('::');

  const openRequest = indexedDB.open(dbName, version);
  const db = await new Promise((resolve, reject) => {
    openRequest.onupgradeneeded = (event) => {
      const dbInstance = event.target.result;
      if (!dbInstance.objectStoreNames.contains(storeName)) {
        dbInstance.createObjectStore(storeName, { keyPath });
      }
      if (typeof onUpgrade === 'function') {
        onUpgrade(dbInstance);
      }
    };
    openRequest.onsuccess = (event) => resolve(event.target.result);
    openRequest.onerror = (event) => reject(event.target.error);
  });

  try {
    const record = await new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, 'readonly');
      const store = tx.objectStore(storeName);
      const request = store.get(compositeKey);

      request.onsuccess = () => resolve(request.result ?? null);
      request.onerror = (event) => reject(event.target.error);
      tx.onerror = (event) => reject(event.target.error);
      tx.onabort = (event) => reject(event.target.error);
    });

    return record;
  } finally {
    db.close();
  }
}

// DELETE COMPOSITE RECORD FROM INDEXEDDB
async function deleteCompositeRecordFromIndexedDb({
  dbName,
  storeName,
  keyFields,
  keySource,
  version = 1,
  keyPath = 'id',
  onUpgrade,
}) {
  if (!dbName || !storeName) {
    throw new Error('dbName と storeName は必須です');
  }
  if (!Array.isArray(keyFields) || keyFields.length === 0) {
    throw new Error('keyFields は1件以上のフィールド名を含む配列で指定してください');
  }
  if (!keySource || typeof keySource !== 'object') {
    throw new Error('keySource はオブジェクトで指定してください');
  }

  const missing = keyFields.filter((field) => !keySource[field]);
  if (missing.length > 0) {
    throw new Error(`複合キーに必要なフィールドが不足しています: ${missing.join(', ')}`);
  }

  const compositeKey = keyFields.map((field) => String(keySource[field])).join('::');

  const openRequest = indexedDB.open(dbName, version);
  const db = await new Promise((resolve, reject) => {
    openRequest.onupgradeneeded = (event) => {
      const dbInstance = event.target.result;
      if (!dbInstance.objectStoreNames.contains(storeName)) {
        dbInstance.createObjectStore(storeName, { keyPath });
      }
      if (typeof onUpgrade === 'function') {
        onUpgrade(dbInstance);
      }
    };
    openRequest.onsuccess = (event) => resolve(event.target.result);
    openRequest.onerror = (event) => reject(event.target.error);
  });

  let existed = false;

  try {
    await new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);

      const getRequest = store.get(compositeKey);
      getRequest.onsuccess = () => {
        existed = Boolean(getRequest.result);
        const deleteRequest = store.delete(compositeKey);
        deleteRequest.onerror = (event) => reject(event.target.error);
      };
      getRequest.onerror = (event) => reject(event.target.error);

      tx.oncomplete = () => resolve();
      tx.onerror = (event) => reject(event.target.error);
      tx.onabort = (event) => reject(event.target.error);
    });
  } finally {
    db.close();
  }

  return { compositeKey, existed };
}

// DEVLOG
function devLog(...words) {
  if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
    console.log(words.join(' '));
  }
  return 1;
}

export {
   handleClickGoTop,
   cleanUpObject,
   toFloat,
   decimalAdjust,
   adjustFloat,
   sleep,
   arrayBufferToBase64,
   postJson,
   syncHttpRequest,
   syncHttpRequestText,
   syncHttpRequest2,
   syncHttpRequestOrThrow,
   hasCamera,
   isIPhone,
   devLog,
   wrapErrorWithCause,
   notificationMessageWithError,
   handleClickScanQr,
   writeOnNfc,
   writeNdefRecordsOnNfc,
   bytesToBase64Url,
   bytesFromBase64Url,
   toBase64Url,
   fromBase64Url,
   readNfc,
   decodeNdefRecord,
   localTime,
   upsertCompositeRecordInIndexedDb,
   updateCompositeRecordInIndexedDb,
   getAllRecordsFromIndexedDb,
   getCompositeRecordFromIndexedDb,
   deleteCompositeRecordFromIndexedDb,
};
